import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const BlacklistAreaDetailRBAC = {
  pageID: '87a89f227f5ae69df5a69421bb8094fa',
  elementID: {
    ViewPage: 'c6e7d6f3ccbf631a7dcc5b2992de7efc',
    Delete: '693082a297d91c700d51ebbcdf85be43',
    Edit: '39341140f3331df6df83f269df0f5476',
    Isochrone: '2842e94a35396fd02fa918ccf1e3914f',
  },
} as const

export const useBlacklistAreaDetailRBACPage = createUseRBAC(BlacklistAreaDetailRBAC.elementID)

export type UseBlacklistAreaDetailRBACPageType = ReturnType<typeof useBlacklistAreaDetailRBACPage>
